/* eslint-disable import/prefer-default-export */

import { ValueObject } from "src/types/common";
import { EntryFormInputType } from "src/types/entryForm";
import { GLOBAL_PARAMS, UTM_PARAMS } from "src/constants/params";
import {
  LOGICAL_GROUP_CHANNEL_CODE,
  RETAIL_LOGICAL_GROUP_CHANNEL_CODE,
} from "src/constants/logicalGroupChannelCode";
import { isEmpty } from "lodash";

type GlobalParams = {
  sRefCode: string;
};

type PlanDirectLinkParams = {
  channelPath: string;
  categoryCode: string;
  planCode: string;
  originUrl: string;
  sRefCode?: string;
};

export const filterParams = (
  params: Partial<GlobalParams & EntryFormInputType>,
  includeList = GLOBAL_PARAMS
): ValueObject<any> => {
  return Object.keys(params || {})
    .filter((key) => includeList.includes(key))
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: params[key],
      }),
      {}
    );
};

// we don't need /${channelPath} in retail
export const formatPathByLogicalGroupChannel = (
  path: string,
  logicalGroupChannel = LOGICAL_GROUP_CHANNEL_CODE
) =>
  logicalGroupChannel !== RETAIL_LOGICAL_GROUP_CHANNEL_CODE
    ? path
    : // this regex will remove first path eg. /retail/health => /health
      path.replace(/^\/?[^/]+/, "") || "/";

export const genPlanDirectLinkShareUrl = (
  {
    channelPath,
    categoryCode,
    planCode,
    originUrl,
    sRefCode,
  }: PlanDirectLinkParams,
  lang: string
): string => {
  const utmQueryString = `${UTM_PARAMS.UTM_SOURCE}=sharebutton&${UTM_PARAMS.UTM_MEDIUM}=healthplanpage&${UTM_PARAMS.UTM_CAMPAIGN}=${planCode}`;
  const sRefCodeQueryString = sRefCode ? `&sRefCode=${sRefCode}` : "";
  const planDirectLinkPath = formatPathByLogicalGroupChannel(
    `/${channelPath}/content-direct/${categoryCode}/plan/${planCode}?${utmQueryString}${sRefCodeQueryString}`
  );

  const planDirectLinkUrl = `${originUrl}/${lang}${planDirectLinkPath}`;

  return planDirectLinkUrl;
};

// only support simple flat query object
export const getUrlWithQuery = (
  path: string,
  query: {
    [key: string]: string | number;
  }
): string => {
  return `${path}${
    isEmpty(query)
      ? ""
      : `?${Object.entries(query)
          .map(([key, val]) => `${key}=${val}`)
          .join("&")}`
  }`;
};
